<template>
  <div class="ShowDocument">
    <div class="button-holder arrow-btn">
      <div class="btn-item back-item">
        <button class="back" @click.prevent="backToList">
          <img src="/img/long-arrow.png" alt="" class="long-arrow light-arrow">
          <img src="/img/long-arrow-dark.png" alt="" class="long-arrow dark-arrow">
          <span>Documents</span>
        </button>
      </div>
    </div>
    <delete-document v-if="isDeleteDocument" :file="item"/>

    <form v-else class="gen-form gen-doc-form">
      <div class="gen-fieldset__item">
        <span class="key">ID</span>
        <span class="value">{{ item.id ? item.id : '' }}</span>
      </div>
      <div class="gen-fieldset__item">
        <span class="key">Title</span>
        <span class="value">{{ item.title }}</span>
      </div>
      <div class="gen-fieldset__item">
        <span class="key">Сreated at</span>
        <span class="value">
          {{ item.created_at ? item.created_at : '' }}
        </span>
      </div>
      <div class="gen-fieldset__item">
        <span class="key">Сreated by</span>
        <span class="value">
          {{ item.user_name ? item.user_name : '' }}
        </span>
      </div>
      <div class="gen-fieldset__item">
        <span class="key">Format</span>
        <span class="value">{{ item.type }}</span>
      </div>
      <div class="gen-fieldset__item">
        <span class="key">Notes</span>
        <span class="value">{{ item.comments }}</span>
      </div>
      <div class="button-wrapper">
        <button class="btn" @click="deleteDocument()">Delete</button>
        <div class="button-holder">
          <!--        <button class="btn attachBtn">Attach to email</button>-->
          <a class="btn" :href="'/documents/'+item.path" download="">Download</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import DeleteDocument from "./DeleteDocument";

export default {
  name: "ShowDocument",
  components: {DeleteDocument},
  props: {
    item: Object,
  },
  computed: {
    isDeleteDocument: {
      get() {
        return this.$store.state.isDeleteDocument
      },
      set(value) {
        this.$store.commit('setter', {isDeleteDocument: value})
      }
    },
    isShowNavigate: {
      get() {
        return this.$store.state.isShowNavigate;
      },
      set(value) {
        this.$store.commit('setter', {isShowNavigate: value})
      }
    },
  },
  methods: {
    backToList() {
      this.changeTab('documents');
      this.isShowDocument = false;
      this.isShowNavigate = true;
    },
    deleteDocument() {
      this.isDeleteDocument = true;
    }
  }
}
</script>

<style lang="scss">
$legend: #726380;

.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dark-arrow {
  display: none;
}

.gen-doc-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.ShowDocument {
  .button-holder {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &.arrow-btn {
      justify-content: flex-start;
      margin-bottom: 50px;

      span {
        display: inline-block;
        margin-left: 5px;
      }
    }

    .btn {
      &.attachBtn {
        color: #a5a5a5;
        margin-right: 20px;
      }
    }
  }

  .key,
  .value {
    display: block;
  }

  .key {
    margin-bottom: 8px;
    color: $legend;
    font-size: 14px;
  }

  .value {
    display: block;
    color: #8d8d8d;
  }
}
</style>
